import React, { useEffect, useMemo } from 'react';
import { useSupabaseStore } from '@/store/SupabaseStore';
import { useToast } from '@/OS/components/ui/use-toast';
import { useUserSettings } from '@/OS/hooks/useUserSettings';
import ModelSelector from '@/components/chat/ModelSelector';

type OSModelSelectorProps = {
  className?: string;
};

const OSModelSelector: React.FC<OSModelSelectorProps> = ({ className }) => {
  const { toast } = useToast();
  const models = useSupabaseStore((state) => state.models);
  const fetchModels = useSupabaseStore((state) => state.fetchModels);
  const { settings, updateSetting } = useUserSettings('mapleos-ai', { defaultModelId: 'maplept-free' });

  useEffect(() => {
    if (!models || models.length === 0) {
      void fetchModels().catch(() => {});
    }
  }, [fetchModels, models]);

  const activeModels = useMemo(
    () => (Array.isArray(models) ? models.filter((model) => model.is_active !== false) : []),
    [models]
  );

  const handleSelect = (modelId: string) => {
    updateSetting('defaultModelId', modelId);
    const chosen = activeModels.find((model) => model.id === modelId);
    toast({
      title: 'Default model updated',
      description: `MapleOS will prefer ${chosen?.name || modelId} for built-in apps.`,
    });
  };

  return (
    <div className={className}>
      <ModelSelector
        models={activeModels}
        selectedModelId={(settings?.defaultModelId as string | undefined) || ''}
        onModelChange={handleSelect}
      />
    </div>
  );
};

export default OSModelSelector;
